<template>
    <div class="bg-main" style="min-height: 100vh;">
        <tabs v-model="type" :tabList="typeList" @change="getOrderList"></tabs>
        <ul class="order-list bg-main px-bigger pt-normal">
            <orderBox class="mb-normal" 
                v-for="order in orderList" 
                :key="order.orderId"
                :dataSource="order"
                @click.native="jumpDetail(order.orderId, order.orderType)">
                <flatCard v-for="orderItem in order.orderItems" 
                    :key="orderItem.itemId"
                    :dataSource="getCardData(orderItem)"
                    :isShowPrice="false"
                />
            </orderBox>
            <h1 v-if="orderList.length === 0" class="center-title">没有订单数据哦！</h1>
        </ul>
    </div>
</template>

<script>
import tabs from '@common/tabs.vue';
import orderBox from '@common/orderBox';
import flatCard from '@common/card/flatCard.vue';
import http from '@/util/http';
export default {
    title() {
        return '我的订单';
    },
    data() {
        return {
            isFromIframe: sessionStorage.getItem('isFromIframe'),
            typeList: [
                {
                    name: '全部',
                    id: -99
                },{
                    name: '待付款',
                    id: -1
                }, {
                    name: '等待出行',
                    id: 2
                }, {
                    name: '出行中',
                    id: 3
                }, {
                    name: '已完成',
                    id: 0
                }, {
                    name: '已取消',
                    id: 1
                }
            ],
            type: -99,
            orderList: []
        };
    },
    methods: {
        getCardData(item) {
            let price;
            let imgUrl = item.imgUrl; 
            if (item.type === 9) {
                price = item.price + (item.virtualName || '积分');
                imgUrl = require('@/assets/images/img_fangquan.png');
                item.total = item.worth;
            } else {
                price = '¥' + item.total;
            }
            const endDate = [0, 6, 9].includes(item.type) ? item.endDate : null;
            let result = [];
            item.specList && item.specList.forEach(e => {
                result.push(...e.specs);
            });
            return {
                imgUrl,
                name: item.name,
                num: item.num,
                isBundle: item.type === 6,
                price,
                originPrice: item.originTotal,
                startDate: item.startDate,
                endDate,
                duration: item.duration,
                // 是否显示自助选房按钮
                isShowBtn: false,
                saveId: item.saveId,
                showDiscount: item.showDiscount,
                total: item.total,
                type: item.type,
                specList: result.join('、')
            };
        },
        getOrderList() {
            const params = {};
            if (this.type !== -99) {
                params.orderStatus = this.type;
            }
            http.get('/directNet/getOrderList', params).then(res => {
                this.orderList = res.data.list;
            });
        },
        jumpDetail(id, type) {
            this.$jump(`orderDetails/${id}?orderType=${type}`);
        }
    },
    components: {
        tabs,
        orderBox,
        flatCard
    },
    created() {
        if (this.$route.query.orderType) {
            this.type = Number(this.$route.query.orderType);
        }
        if (this.isFromIframe) {
            this.typeList.length = 4;
        }
        this.getOrderList();
    }
};
</script>
<style lang="scss">
    .order-list {
        position: absolute;
        top: 0.9rem;
        bottom: 0;
        width: 100%;
        overflow: auto;
    }
</style>
